import { render } from "./IconPencilEdit.vue?vue&type=template&id=42b41cb4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconPencilEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42b41cb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42b41cb4', __exports__)) {
    api.reload('42b41cb4', __exports__)
  }
  
  module.hot.accept("./IconPencilEdit.vue?vue&type=template&id=42b41cb4", () => {
    api.rerender('42b41cb4', render)
  })

}


export default __exports__